var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#D9008D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.345 18L23.3475 15H20.655L18.6525 18H21.345ZM18.8475 15H17.25C16.6533 15 16.081 15.2371 15.659 15.659C15.2371 16.081 15 16.6533 15 17.25V18H16.845L18.8475 15ZM15 24.75C15 25.3467 15.2371 25.919 15.659 26.341C16.081 26.7629 16.6533 27 17.25 27H24.75C25.3467 27 25.919 26.7629 26.341 26.341C26.7629 25.919 27 25.3467 27 24.75V19.5H15V24.75ZM26.4675 15.8025C26.122 15.4026 25.6467 15.1371 25.125 15.0525L23.1525 18H27V17.25C26.9986 16.7198 26.81 16.2072 26.4675 15.8025Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.cebbb6ea6a413f254d934ee3a9110912.svg";
export { ForwardRef as ReactComponent };